/* ET Brands Marketplace — theme.js */
(function () {
  'use strict';

  var cfg = window.themeConfig || {};

  /* ---------- Money formatter (replica el helper estándar de Shopify) ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var fmt = format || cfg.moneyFormat || '${{amount}}';
    function thousands(num, precision, thousand, decimal) {
      precision = isNaN(precision = Math.abs(precision)) ? 2 : precision;
      thousand = thousand || ',';
      decimal = decimal || '.';
      var neg = cents < 0 ? '-' : '';
      var n = (Math.abs(cents) / 100).toFixed(precision);
      var parts = n.split('.');
      var intPart = parts[0].replace(/(\d)(?=(\d{3})+$)/g, '$1' + thousand);
      var decPart = parts[1] ? decimal + parts[1] : '';
      return neg + intPart + decPart;
    }
    var value = '';
    var match = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var placeholder = match ? match[1] : 'amount';
    switch (placeholder) {
      case 'amount': value = thousands(cents, 2, '.', ','); break;
      case 'amount_no_decimals': value = thousands(cents, 0, '.', ','); break;
      case 'amount_with_comma_separator': value = thousands(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = thousands(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = thousands(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = thousands(cents, 0, ' ', ''); break;
      default: value = thousands(cents, 2, '.', ',');
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  /* ---------- Hero slideshow ---------- */
  document.querySelectorAll('[data-hero]').forEach(function (hero) {
    var track = hero.querySelector('[data-hero-track]');
    var slides = track ? track.children : [];
    if (slides.length < 2) return;
    var dots = hero.querySelectorAll('[data-hero-dot]');
    var autoplay = hero.getAttribute('data-autoplay') !== 'false';
    var index = 0, timer = null;
    function go(i) {
      index = (i + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + index * 100 + '%)';
      dots.forEach(function (d, di) { d.classList.toggle('active', di === index); });
    }
    function next() { go(index + 1); }
    function start() { if (!autoplay) return; stop(); timer = setInterval(next, 5500); }
    function stop() { if (timer) clearInterval(timer); }
    var nextBtn = hero.querySelector('[data-hero-next]');
    var prevBtn = hero.querySelector('[data-hero-prev]');
    if (nextBtn) nextBtn.addEventListener('click', function () { go(index + 1); start(); });
    if (prevBtn) prevBtn.addEventListener('click', function () { go(index - 1); start(); });
    dots.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.dataset.heroDot, 10)); start(); }); });
    hero.addEventListener('mouseenter', stop);
    hero.addEventListener('mouseleave', start);
    start();
  });

  /* ---------- Mobile menu ---------- */
  var menuToggle = document.querySelector('[data-menu-toggle]');
  var mobileMenu = document.querySelector('[data-mobile-menu]');
  var mobileScrim = document.querySelector('[data-mobile-scrim]');
  var menuClose = document.querySelector('[data-menu-close]');
  function openMenu() { if (!mobileMenu) return; mobileMenu.classList.add('open'); if (mobileScrim) mobileScrim.classList.add('open'); if (menuToggle) menuToggle.setAttribute('aria-expanded', 'true'); }
  function closeMenu() { if (!mobileMenu) return; mobileMenu.classList.remove('open'); if (mobileScrim) mobileScrim.classList.remove('open'); if (menuToggle) menuToggle.setAttribute('aria-expanded', 'false'); }
  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', function (e) { e.stopPropagation(); mobileMenu.classList.contains('open') ? closeMenu() : openMenu(); });
    if (menuClose) menuClose.addEventListener('click', closeMenu);
    if (mobileScrim) mobileScrim.addEventListener('click', closeMenu);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeMenu(); });
  }

  /* Header compacto al hacer scroll (oculta barra de anuncios en móvil) */
  window.addEventListener('scroll', function () {
    var y = window.pageYOffset || document.documentElement.scrollTop;
    document.body.classList.toggle('scrolled', y > 80);
  }, { passive: true });

  /* Buscador colapsable en móvil */
  var searchToggle = document.querySelector('[data-search-toggle]');
  var headerEl = document.querySelector('[data-header]');
  if (searchToggle && headerEl) {
    searchToggle.addEventListener('click', function () {
      headerEl.classList.toggle('search-open');
      if (headerEl.classList.contains('search-open')) {
        var inp = headerEl.querySelector('[data-predictive-input]') || headerEl.querySelector('.search-form input');
        if (inp) setTimeout(function () { inp.focus(); }, 60);
      }
    });
  }

  /* ---------- Product gallery carousel (swipe + flechas + autoplay) ---------- */
  var pgal = document.querySelector('[data-pgal]');
  if (pgal) {
    var track = pgal.querySelector('[data-pgal-track]');
    var dots = Array.prototype.slice.call(pgal.querySelectorAll('[data-pgal-dot]'));
    var nSlides = track.children.length;
    var idx = 0, timer = null, AUTOPLAY = 2800;

    function goTo(i) {
      idx = (i + nSlides) % nSlides;
      track.scrollTo({ left: track.clientWidth * idx, behavior: 'smooth' });
    }
    function syncDots() {
      var i = Math.round(track.scrollLeft / track.clientWidth);
      if (i !== idx) idx = i;
      dots.forEach(function (d, j) { d.classList.toggle('active', j === idx); });
    }
    function startAuto() {
      if (nSlides < 2) return;
      stopAuto();
      timer = setInterval(function () { goTo(idx + 1); }, AUTOPLAY);
    }
    function stopAuto() { if (timer) { clearInterval(timer); timer = null; } }
    function restart() { stopAuto(); startAuto(); }

    var prev = pgal.querySelector('[data-pgal-prev]');
    var next = pgal.querySelector('[data-pgal-next]');
    if (prev) prev.addEventListener('click', function () { goTo(idx - 1); restart(); });
    if (next) next.addEventListener('click', function () { goTo(idx + 1); restart(); });
    dots.forEach(function (d) {
      d.addEventListener('click', function () { goTo(parseInt(d.dataset.pgalDot, 10)); restart(); });
    });

    var st;
    track.addEventListener('scroll', function () { clearTimeout(st); st = setTimeout(syncDots, 90); }, { passive: true });
    pgal.addEventListener('mouseenter', stopAuto);
    pgal.addEventListener('mouseleave', startAuto);
    track.addEventListener('touchstart', stopAuto, { passive: true });
    track.addEventListener('touchend', function () { setTimeout(restart, 4000); }, { passive: true });
    window.addEventListener('resize', function () { track.scrollLeft = track.clientWidth * idx; });

    startAuto();
  }

  /* ---------- Reviews: formulario (estrellas + envío al Worker) ---------- */
  var rForm = document.querySelector('[data-review-form]');
  if (rForm) {
    var rOpen = document.querySelector('[data-review-open]');
    if (rOpen) rOpen.addEventListener('click', function () {
      rForm.hidden = !rForm.hidden;
      if (!rForm.hidden) rForm.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
    var starWrap = rForm.querySelector('[data-star-input]');
    var ratingInput = rForm.querySelector('[data-rating-value]');
    if (starWrap && ratingInput) {
      var rStars = Array.prototype.slice.call(starWrap.querySelectorAll('.rf-star'));
      rStars.forEach(function (s) {
        s.addEventListener('click', function () {
          var n = parseInt(s.dataset.star, 10);
          ratingInput.value = n;
          rStars.forEach(function (x, i) { x.classList.toggle('is-on', i < n); });
        });
      });
    }
    rForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var msg = rForm.querySelector('[data-review-msg]');
      var submitBtn = rForm.querySelector('[data-review-submit]');
      var hp = rForm.querySelector('.rf-hp');
      if (hp && hp.value) { return; }
      var endpoint = rForm.dataset.endpoint;
      if (!endpoint) { msg.textContent = 'Las reseñas aún se están configurando. Intenta más tarde.'; msg.className = 'review-form__msg is-err'; return; }
      msg.textContent = 'Enviando…'; msg.className = 'review-form__msg';
      submitBtn.disabled = true;
      fetch(endpoint, { method: 'POST', body: new FormData(rForm) })
        .then(function (r) { return r.json().catch(function () { return { ok: r.ok }; }); })
        .then(function (d) {
          if (d && d.ok) {
            msg.textContent = '¡Gracias! Tu reseña fue enviada y se publicará tras una revisión.';
            msg.className = 'review-form__msg is-ok';
            rForm.reset();
          } else {
            msg.textContent = (d && d.error) || 'No pudimos enviar tu reseña. Revisa los datos e intenta de nuevo.';
            msg.className = 'review-form__msg is-err';
          }
        })
        .catch(function () { msg.textContent = 'Error de conexión. Intenta nuevamente.'; msg.className = 'review-form__msg is-err'; })
        .finally(function () { submitBtn.disabled = false; });
    });
  }

  /* ---------- Reviews: "ver más" + lightbox de fotos ---------- */
  var moreBtn = document.querySelector('[data-reviews-more]');
  if (moreBtn) {
    moreBtn.addEventListener('click', function () {
      document.querySelectorAll('.review-card--extra[hidden]').forEach(function (c) { c.hidden = false; });
      moreBtn.remove();
    });
  }
  var lb = document.querySelector('[data-review-lightbox]');
  if (lb) {
    var lbImg = lb.querySelector('[data-lightbox-img]');
    var lbVid = lb.querySelector('[data-lightbox-video]');
    // Galería con todas las fotos/videos de reseñas, navegables con flechas
    var media = Array.prototype.slice.call(document.querySelectorAll('[data-review-media]')).map(function (b) {
      return { type: b.getAttribute('data-review-media'), src: b.getAttribute('data-review-src') };
    });
    var cur = 0;
    function stopVid() { if (lbVid) { try { lbVid.pause(); } catch (e) {} lbVid.removeAttribute('src'); lbVid.load && lbVid.load(); lbVid.hidden = true; } }
    function render(i) {
      if (!media.length) return;
      cur = (i + media.length) % media.length;
      var it = media[cur];
      if (it.type === 'video' && lbVid) {
        if (lbImg) lbImg.hidden = true;
        lbVid.src = it.src; lbVid.hidden = false; try { lbVid.play(); } catch (e) {}
      } else {
        stopVid();
        if (lbImg) { lbImg.src = it.src; lbImg.hidden = false; }
      }
    }
    function openLb(i) { render(i); lb.hidden = false; document.body.style.overflow = 'hidden'; lb.classList.toggle('has-nav', media.length > 1); }
    var closeLb = function () { lb.hidden = true; if (lbImg) lbImg.src = ''; stopVid(); document.body.style.overflow = ''; };
    document.querySelectorAll('[data-review-media]').forEach(function (btn, i) {
      btn.addEventListener('click', function () { openLb(i); });
    });
    var lbPrev = lb.querySelector('[data-lightbox-prev]');
    var lbNext = lb.querySelector('[data-lightbox-next]');
    if (lbPrev) lbPrev.addEventListener('click', function (e) { e.stopPropagation(); render(cur - 1); });
    if (lbNext) lbNext.addEventListener('click', function (e) { e.stopPropagation(); render(cur + 1); });
    lb.addEventListener('click', function (e) {
      if (e.target === lb || e.target.hasAttribute('data-lightbox-close')) closeLb();
    });
    document.addEventListener('keydown', function (e) {
      if (lb.hidden) return;
      if (e.key === 'Escape') closeLb();
      else if (e.key === 'ArrowLeft') render(cur - 1);
      else if (e.key === 'ArrowRight') render(cur + 1);
    });
  }

  /* ---------- Quantity steppers (product) ---------- */
  document.querySelectorAll('[data-product]').forEach(function (scope) {
    var input = scope.querySelector('.product__qty input');
    var minus = scope.querySelector('[data-qty-minus]');
    var plus = scope.querySelector('[data-qty-plus]');
    if (!input) return;
    if (minus) minus.addEventListener('click', function () { input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1); });
    if (plus) plus.addEventListener('click', function () { input.value = (parseInt(input.value, 10) || 1) + 1; });
  });

  /* ---------- Variant selection (precio, cuotas, sticky, botón) ---------- */
  var form = document.getElementById('ProductForm');
  if (form) {
    var variantSelect = form.querySelector('[data-variant-select]');
    var optionSelectors = form.querySelectorAll('[data-option-selector]');
    var priceEl = document.querySelector('[data-price]');
    var addBtn = form.querySelector('[data-add-btn]');
    var addText = form.querySelector('[data-add-text]');
    var installmentEl = document.querySelector('[data-installment-amount]');
    var installmentsWrap = document.querySelector('[data-installments]');
    var stickyPrice = document.querySelector('[data-sticky-price]');

    function currentOptions() { return Array.prototype.map.call(optionSelectors, function (s) { return s.value; }); }
    function updateVariant() {
      if (!variantSelect) return;
      var opts = currentOptions().join(' / ');
      var options = variantSelect.options;
      for (var i = 0; i < options.length; i++) {
        var label = options[i].textContent.replace(' - Agotado', '').trim();
        if (label === opts) {
          variantSelect.selectedIndex = i;
          var sel = options[i];
          var cents = parseInt(sel.getAttribute('data-price-cents'), 10);
          if (sel.dataset.price && priceEl) priceEl.textContent = sel.dataset.price;
          if (sel.dataset.price && stickyPrice) stickyPrice.textContent = sel.dataset.price;
          if (installmentEl && installmentsWrap && !isNaN(cents)) {
            var count = parseInt(installmentsWrap.getAttribute('data-count'), 10) || 12;
            installmentEl.textContent = formatMoney(Math.round(cents / count));
          }
          if (addBtn) {
            addBtn.disabled = sel.disabled;
            if (addText) addText.textContent = sel.disabled ? 'Agotado' : 'Agregar al carrito';
          }
          break;
        }
      }
    }
    optionSelectors.forEach(function (s) { s.addEventListener('change', updateVariant); });
  }

  /* ---------- Cart drawer + AJAX ---------- */
  var drawer = document.querySelector('[data-cart-drawer]');
  var overlay = document.querySelector('[data-drawer-overlay]');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    if (overlay) { overlay.hidden = false; requestAnimationFrame(function () { overlay.classList.add('show'); }); }
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    if (overlay) { overlay.classList.remove('show'); setTimeout(function () { overlay.hidden = true; }, 250); }
    document.body.style.overflow = '';
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });
    var dc = document.querySelector('[data-drawer-count]');
    if (dc) dc.textContent = count;
  }

  function milestones() {
    var ms = [];
    if (cfg.freeShipping && cfg.freeShippingThreshold) ms.push({ t: cfg.freeShippingThreshold, label: 'el envío gratis', icon: '🚚' });
    if (cfg.reward2 && cfg.reward2Threshold) ms.push({ t: cfg.reward2Threshold, label: cfg.reward2Label || 'tu regalo', icon: '🎁' });
    return ms.sort(function (a, b) { return a.t - b.t; });
  }
  function updateShipBars(total) {
    var ms = milestones();
    if (!ms.length) return;
    var maxT = ms[ms.length - 1].t;
    var next = ms.find(function (m) { return total < m.t; });
    document.querySelectorAll('[data-ship-bar]').forEach(function (bar) {
      var fill = bar.querySelector('[data-ship-fill]');
      var text = bar.querySelector('[data-ship-text]');
      var pct = Math.min(100, Math.round(total * 100 / maxT));
      if (fill) fill.style.width = pct + '%';
      if (text) {
        if (!next) {
          text.innerHTML = '✓ <strong>¡Ganaste ' + ms.map(function (m) { return m.label; }).join(' y ') + '!</strong> 🎉';
        } else {
          text.innerHTML = 'Te faltan <strong>' + formatMoney(next.t - total) + '</strong> para <strong>' + next.label + '</strong> ' + next.icon;
        }
      }
    });
  }

  function updateMayoristaBar(units) {
    document.querySelectorAll('[data-mayo-bar]').forEach(function (bar) {
      var th = parseInt(bar.getAttribute('data-mthreshold'), 10) || 10;
      var fill = bar.querySelector('[data-mayo-fill]');
      var text = bar.querySelector('[data-mayo-text]');
      var remaining = th - units;
      var pct = Math.min(100, Math.round(units * 100 / th));
      if (fill) fill.style.width = pct + '%';
      bar.classList.toggle('mayo-bar--won', remaining <= 0);
      if (text) {
        if (remaining <= 0) {
          text.innerHTML = '🎟️ <strong>¡Ganaste tu descuento mayorista de 15%!</strong>';
        } else {
          text.innerHTML = '🔥 Te faltan <strong>' + remaining + '</strong> ' + (remaining === 1 ? 'unidad' : 'unidades') + ' para tu <strong>15% mayorista</strong>';
        }
      }
    });
  }
  window.__updateMayoristaBar = updateMayoristaBar;

  function renderDrawer(cart) {
    if (!drawer) return;
    var itemsWrap = drawer.querySelector('[data-drawer-items]');
    var emptyEl = drawer.querySelector('[data-drawer-empty]');
    var footEl = drawer.querySelector('[data-drawer-foot]');
    var docEl = drawer.querySelector('[data-drawer-doc]');
    var barsEl = drawer.querySelector('.cart-drawer__bars');
    updateCartCount(cart.item_count);
    updateShipBars(cart.total_price);
    updateMayoristaBar(cart.item_count);
    updateDrawerRecs(cart);

    // Totales: precio full, descuentos aplicados y subtotal
    var fullEl = drawer.querySelector('[data-drawer-full]');
    var discEl = drawer.querySelector('[data-drawer-disc]');
    var subtotal = drawer.querySelector('[data-drawer-subtotal]');
    var fullRow = drawer.querySelector('[data-drawer-fullrow]');
    var discRow = drawer.querySelector('[data-drawer-discrow]');
    var hasDiscount = (cart.total_discount || 0) > 0;
    if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
    if (fullEl) fullEl.textContent = formatMoney(cart.original_total_price);
    if (discEl) discEl.textContent = '−' + formatMoney(cart.total_discount);
    if (fullRow) fullRow.hidden = !hasDiscount;
    if (discRow) discRow.hidden = !hasDiscount;

    if (cart.item_count === 0) {
      if (itemsWrap) itemsWrap.innerHTML = '';
      if (emptyEl) emptyEl.hidden = false;
      if (footEl) footEl.style.display = 'none';
      if (docEl) docEl.style.display = 'none';
      if (barsEl) barsEl.style.display = 'none';
      return;
    }
    if (emptyEl) emptyEl.hidden = true;
    if (footEl) footEl.style.display = '';
    if (docEl) docEl.style.display = '';
    if (barsEl) barsEl.style.display = '';

    var html = cart.items.map(function (item) {
      var img = item.image ? item.image.replace(/(\.[^.]*)$/, '_120x$1') : '';
      var variant = (item.variant_title && item.variant_title !== 'Default Title') ? '<div class="di__variant">' + item.variant_title + '</div>' : '';
      var unitDisc = item.original_price > item.final_price;
      var lineDisc = item.original_line_price > item.final_line_price;
      var priceHtml = (unitDisc ? '<s class="di__was">' + formatMoney(item.original_price) + '</s>' : '') + formatMoney(item.final_price);
      var totalHtml = (lineDisc ? '<s class="di__was">' + formatMoney(item.original_line_price) + '</s>' : '') + formatMoney(item.final_line_price);
      return '<div class="di" data-line-item>' +
        '<a href="' + item.url + '"><img src="' + img + '" alt="" width="64"></a>' +
        '<div class="di__info">' +
          '<a href="' + item.url + '" class="di__title">' + item.product_title + '</a>' + variant +
          '<div class="di__price">' + priceHtml + '</div>' +
          '<div class="di__qty">' +
            '<button type="button" data-line-minus data-key="' + item.key + '" aria-label="Restar">−</button>' +
            '<span>' + item.quantity + '</span>' +
            '<button type="button" data-line-plus data-key="' + item.key + '" aria-label="Sumar">+</button>' +
            '<button type="button" class="di__remove" data-line-remove data-key="' + item.key + '">Quitar</button>' +
          '</div>' +
        '</div>' +
        '<div class="di__total">' + totalHtml + '</div>' +
      '</div>';
    }).join('');
    if (itemsWrap) itemsWrap.innerHTML = html;
  }

  function refreshCart(open) {
    return fetch(cfg.cartUrl + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderDrawer(cart); if (open) openDrawer(); return cart; });
  }

  function changeLine(key, qty) {
    return fetch((cfg.changeUrl || '/cart/change') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function (cart) { renderDrawer(cart); return cart; });
  }

  // Delegated controls inside the drawer
  if (drawer) {
    drawer.addEventListener('click', function (e) {
      var t = e.target.closest('[data-key]');
      if (!t) return;
      var key = t.getAttribute('data-key');
      var span = t.parentNode.querySelector('span');
      var current = span ? parseInt(span.textContent, 10) : 1;
      if (t.hasAttribute('data-line-plus')) changeLine(key, current + 1);
      else if (t.hasAttribute('data-line-minus')) changeLine(key, Math.max(0, current - 1));
      else if (t.hasAttribute('data-line-remove')) changeLine(key, 0);
    });
  }

  // Boleta / Factura dentro del drawer → guarda en atributos del carrito
  (function () {
    if (!drawer) return;
    var docBox = drawer.querySelector('[data-drawer-doc]');
    if (!docBox) return;
    var fields = docBox.querySelector('[data-cd-factura-fields]');
    var note = docBox.querySelector('[data-cd-factura-note]');
    function isFactura() { var f = docBox.querySelector('[data-cd-doc-radio][value="Factura"]'); return !!(f && f.checked); }
    function toggle() { var on = isFactura(); if (fields) fields.hidden = !on; if (note) note.hidden = !on; }
    var saveTimer;
    function saveAttrs() {
      var attrs = { 'Documento': isFactura() ? 'Factura' : 'Boleta' };
      docBox.querySelectorAll('[data-cd-attr]').forEach(function (inp) { attrs[inp.getAttribute('data-cd-attr')] = inp.value; });
      clearTimeout(saveTimer);
      saveTimer = setTimeout(function () {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ attributes: attrs })
        });
      }, 500);
    }
    docBox.addEventListener('change', function (e) { if (e.target.matches('[data-cd-doc-radio]')) { toggle(); saveAttrs(); } });
    docBox.addEventListener('input', function (e) { if (e.target.matches('[data-cd-attr]')) saveAttrs(); });
  })();

  // Open/close triggers
  document.querySelectorAll('[data-cart-toggle]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      if (cfg.cartDrawer) { e.preventDefault(); refreshCart(true); }
    });
  });
  document.querySelectorAll('[data-drawer-close]').forEach(function (el) { el.addEventListener('click', closeDrawer); });
  if (overlay) overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  /* ---------- AJAX add to cart ---------- */
  if (form && cfg.cartDrawer) {
    var addButton = form.querySelector('[data-add-btn]');
    var addLabel = form.querySelector('[data-add-text]');
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (addButton) addButton.disabled = true;
      if (addLabel) addLabel.textContent = 'Agregando…';
      fetch((cfg.addUrl || '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form)
      }).then(function (r) { return r.json(); })
        .then(function () { return refreshCart(true); })
        .catch(function () { form.submit(); })
        .finally(function () {
          if (addButton) addButton.disabled = false;
          if (addLabel) addLabel.textContent = 'Agregar al carrito';
        });
    });
  }

  /* ---------- Quick add desde tarjetas de producto ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    var id = btn.getAttribute('data-variant-id');
    if (!id || btn.disabled) return;
    var labelEl = btn.querySelector('span') || btn;
    var original = labelEl.textContent;
    btn.disabled = true;
    labelEl.textContent = 'Agregando…';
    fetch((cfg.addUrl || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: id, quantity: 1 })
    }).then(function (r) { return r.json(); })
      .then(function () {
        labelEl.textContent = '✓ Agregado';
        if (cfg.cartDrawer) { refreshCart(true); }
        else { return fetch(cfg.cartUrl + '.js').then(function (r) { return r.json(); }).then(function (c) { updateCartCount(c.item_count); }); }
      })
      .catch(function () { window.location.href = cfg.cartUrl || '/cart'; })
      .finally(function () {
        setTimeout(function () { btn.disabled = false; labelEl.textContent = original; }, 1400);
      });
  });

  /* ---------- Sticky add-to-cart ---------- */
  var stickyAdd = document.querySelector('[data-sticky-add]');
  var stickyBar = document.querySelector('[data-sticky-atc]');
  if (stickyAdd && form) {
    stickyAdd.addEventListener('click', function () {
      var realBtn = form.querySelector('[data-add-btn]');
      if (realBtn) realBtn.click();
    });
  }
  if (stickyBar && form) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var show = !en.isIntersecting;
        stickyBar.classList.toggle('visible', show);
        document.body.classList.toggle('sticky-atc-on', show);
      });
    }, { rootMargin: '-120px 0px 0px 0px' });
    var watch = form.querySelector('[data-add-btn]') || form;
    if (watch) io.observe(watch);
  }

  /* ---------- Predictive search ---------- */
  var pInput = document.querySelector('[data-predictive-input]');
  var pResults = document.querySelector('[data-predictive-results]');
  if (pInput && pResults && cfg.predictive) {
    var debounce;
    pInput.addEventListener('input', function () {
      var q = pInput.value.trim();
      clearTimeout(debounce);
      if (q.length < 2) { pResults.hidden = true; pResults.innerHTML = ''; return; }
      debounce = setTimeout(function () {
        var url = (cfg.predictiveUrl || '/search/suggest') + '.json?q=' + encodeURIComponent(q) +
          '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
        fetch(url, { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (!products.length) {
              pResults.innerHTML = '<div class="predictive__empty">Sin resultados para “' + q + '”</div>';
              pResults.hidden = false; return;
            }
            pResults.innerHTML = products.map(function (p) {
              var img = (p.featured_image && p.featured_image.url) ? p.featured_image.url : (p.image || '');
              var price = (typeof p.price !== 'undefined') ? formatMoney(Math.round(parseFloat(p.price) * 100)) : '';
              return '<a href="' + p.url + '" class="predictive__item">' +
                (img ? '<img src="' + img + '" alt="" width="44">' : '') +
                '<span class="predictive__title">' + p.title + '</span>' +
                '<span class="predictive__price">' + price + '</span></a>';
            }).join('') + '<a href="/search?q=' + encodeURIComponent(q) + '" class="predictive__all">Ver todos los resultados →</a>';
            pResults.hidden = false;
          }).catch(function () { pResults.hidden = true; });
      }, 220);
    });
    document.addEventListener('click', function (e) {
      var wrap = document.querySelector('[data-search-wrap]');
      if (wrap && !wrap.contains(e.target)) pResults.hidden = true;
    });
    pInput.addEventListener('focus', function () { if (pResults.innerHTML) pResults.hidden = false; });
  }

  /* ========================================================================
     AOV — recomendaciones, FBT, cross-sell, vistos recientemente, quiebres
     ======================================================================== */

  // Normaliza productos de /collections/x/products.json (precio string) al formato de recs (precio en cents)
  function normalizeFallback(products, excludeId) {
    return (products || []).filter(function (p) { return String(p.id) !== String(excludeId); }).map(function (p) {
      var v = (p.variants && p.variants[0]) || {};
      var img = p.featured_image || (p.images && p.images[0] && (p.images[0].src || p.images[0])) || '';
      return {
        id: p.id,
        title: p.title,
        url: '/products/' + p.handle,
        featured_image: img,
        product_type: p.product_type || '',
        price: Math.round(parseFloat(v.price || p.price || 0) * 100),
        compare_at_price: v.compare_at_price ? Math.round(parseFloat(v.compare_at_price) * 100) : 0,
        variants: (p.variants || []).map(function (x) { return { id: x.id }; })
      };
    });
  }
  function fetchFallback(limit, excludeId, ptype) {
    var h = cfg.recsFallback;
    if (!h) return Promise.resolve([]);
    // Pide de más para poder filtrar por categoría
    return fetch('/collections/' + h + '/products.json?limit=' + ((limit || 8) * 3), { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (d) {
        var list = normalizeFallback(d.products, excludeId);
        if (ptype) {
          var same = list.filter(function (p) { return p.product_type === ptype; });
          if (same.length) list = same;
        }
        return list.slice(0, limit || 8);
      })
      .catch(function () { return []; });
  }
  function fetchRecs(productId, intent, limit, excludeId, ptype) {
    var base = cfg.recommendationsUrl || '/recommendations/products';
    var url = base + '.json?product_id=' + productId + '&limit=' + (limit || 8) + '&intent=' + (intent || 'related');
    return fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) { return (d.products || []); })
      .catch(function () { return []; })
      .then(function (products) { return products.length ? products : fetchFallback(limit, excludeId || productId, ptype); });
  }

  function recCardHTML(p) {
    var img = p.featured_image || (p.images && p.images[0]) || '';
    var onSale = p.compare_at_price && p.compare_at_price > p.price;
    var single = p.variants && p.variants.length === 1;
    var cta = single
      ? '<button type="button" class="btn btn--primary btn--block card__cta" data-quick-add data-variant-id="' + p.variants[0].id + '"><span>Agregar</span></button>'
      : '<a href="' + p.url + '" class="btn btn--primary btn--block card__cta">Ver opciones</a>';
    return '<div class="card">' +
      '<a href="' + p.url + '" class="card__media">' + (onSale ? '<span class="card__badge">Oferta</span>' : '') +
        (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</a>' +
      '<div class="card__body">' +
        '<a href="' + p.url + '" class="card__title">' + p.title + '</a>' +
        '<div class="card__price"><div class="price"><span class="price__current">' + formatMoney(p.price) + '</span>' +
          (onSale ? '<span class="price__compare">' + formatMoney(p.compare_at_price) + '</span>' : '') + '</div></div>' +
        cta +
      '</div></div>';
  }

  // Hydrate rec containers (PDP related + cart cross-sell)
  document.querySelectorAll('[data-recommendations]').forEach(function (box) {
    var pid = box.getAttribute('data-product-id');
    var section = box.closest('[data-recommendations-section]');
    if (!pid) { if (section) section.remove(); return; }
    var intent = box.getAttribute('data-intent') || 'related';
    var limit = parseInt(box.getAttribute('data-limit'), 10) || 10;
    fetchRecs(pid, intent, limit).then(function (products) {
      if (!products.length) { if (section) section.remove(); return; }
      var row = box.querySelector('[data-rec-row]');
      if (row) row.innerHTML = products.map(recCardHTML).join('');
      if (section) section.hidden = false;
    });
  });

  // Drawer cross-sell / post-add upsell / free-shipping closer
  function drawerRecHTML(p) {
    var img = p.featured_image || '';
    var single = p.variants && p.variants.length === 1;
    var btn = single
      ? '<button type="button" class="dr__add" data-quick-add data-variant-id="' + p.variants[0].id + '" aria-label="Agregar">+</button>'
      : '<a href="' + p.url + '" class="dr__add" aria-label="Ver">→</a>';
    return '<div class="dr"><a href="' + p.url + '" class="dr__img">' + (img ? '<img src="' + img + '" alt="">' : '') + '</a>' +
      '<div class="dr__info"><a href="' + p.url + '" class="dr__title">' + p.title + '</a>' +
      '<span class="dr__price">' + formatMoney(p.price) + '</span></div>' + btn + '</div>';
  }
  function updateDrawerRecs(cart) {
    var box = drawer && drawer.querySelector('[data-drawer-recs]');
    if (!box || !cfg.cartRecs) return;
    if (!cart.item_count) { box.hidden = true; box.innerHTML = ''; box.removeAttribute('data-pid'); return; }
    var pid = cart.items[0].product_id;
    var ptype = cart.items[0].product_type || '';
    if (box.getAttribute('data-pid') === String(pid)) return;
    box.setAttribute('data-pid', String(pid));
    // 'related' = motor nativo de Shopify por categoría/co-compra; priorizamos misma categoría que lo que ya llevas
    fetchRecs(pid, 'related', 12, pid, ptype).then(function (products) {
      var inCart = {};
      cart.items.forEach(function (i) { inCart[i.product_id] = true; });
      products = products.filter(function (p) { return !inCart[p.id]; });
      if (ptype) {
        var same = products.filter(function (p) { return (p.product_type || '') === ptype; });
        var rest = products.filter(function (p) { return (p.product_type || '') !== ptype; });
        products = same.concat(rest);
      }
      products = products.slice(0, 4);
      if (!products.length) { box.hidden = true; return; }
      var ms = milestones();
      var nextMs = ms.find(function (m) { return cart.total_price < m.t; });
      var title = (cfg.freeshipAddon && nextMs) ? 'Súmalo y consigue ' + nextMs.label + ' ' + nextMs.icon : 'Completa tu compra';
      box.innerHTML = '<div class="drawer-recs__title">' + title + '</div><div class="drawer-recs__row">' + products.map(drawerRecHTML).join('') + '</div>';
      box.hidden = false;
    });
  }
  window.__updateDrawerRecs = updateDrawerRecs;

  // Frequently Bought Together
  var fbt = document.querySelector('[data-fbt]');
  if (fbt) {
    var fpid = fbt.getAttribute('data-product-id');
    fetchRecs(fpid, 'complementary', 4).then(function (products) {
      products = products.filter(function (p) { return p.variants && p.variants.length === 1; }).slice(0, 2);
      var section = fbt.closest('[data-fbt-section]');
      if (!products.length) { if (section) section.remove(); return; }
      var main = {
        id: fbt.getAttribute('data-main-variant'),
        title: fbt.getAttribute('data-main-title'),
        image: fbt.getAttribute('data-main-image'),
        price: parseInt(fbt.getAttribute('data-main-price'), 10),
        url: fbt.getAttribute('data-main-url')
      };
      var items = [{ vid: main.id, price: main.price, title: main.title, image: main.image, url: main.url, main: true }]
        .concat(products.map(function (p) { return { vid: p.variants[0].id, price: p.price, title: p.title, image: p.featured_image, url: p.url }; }));
      var disc = cfg.fbtDiscount || {};
      function pctFor(extras) {
        if (!disc.enabled) return 0;
        if (extras >= 2) return disc.d2 || 0;
        if (extras === 1) return disc.d1 || 0;
        return 0;
      }
      function render() {
        var checked = items.filter(function (it) { return it.checked !== false; });
        var extras = checked.length - 1;
        var total = checked.reduce(function (s, it) { return s + it.price; }, 0);
        var pct = pctFor(extras);
        var fin = Math.round(total * (1 - pct / 100));
        fbt.querySelector('[data-fbt-count]').textContent = checked.length;
        var totalEl = fbt.querySelector('[data-fbt-total]');
        if (pct > 0) {
          totalEl.innerHTML = '<span class="fbt__was">' + formatMoney(total) + '</span> ' + formatMoney(fin) + ' <span class="fbt__save">−' + pct + '%</span>';
        } else {
          totalEl.textContent = formatMoney(total);
        }
        var hint = fbt.querySelector('[data-fbt-hint]');
        if (hint) {
          if (extras >= 2) hint.textContent = '🎉 Llevas el combo completo y ahorras ' + disc.d2 + '%';
          else if (extras === 1) hint.textContent = '➕ Agrega el otro producto y sube tu ahorro a ' + disc.d2 + '%';
          else hint.textContent = 'Agrega 1 y ahorra ' + disc.d1 + '% · los 2 y ahorra ' + disc.d2 + '%';
        }
      }
      fbt.innerHTML =
        '<div class="fbt__items">' + items.map(function (it, i) {
          return '<label class="fbt__item' + (it.main ? ' fbt__item--main' : '') + '">' +
            '<input type="checkbox" ' + (it.main ? 'checked disabled' : 'checked') + ' data-fbt-check="' + i + '">' +
            '<img src="' + (it.image || '') + '" alt=""><span class="fbt__t">' + it.title + '</span>' +
            '<span class="fbt__p">' + formatMoney(it.price) + '</span></label>' +
            (i < items.length - 1 ? '<span class="fbt__plus">+</span>' : '');
        }).join('') + '</div>' +
        (disc.enabled ? '<p class="fbt__hint" data-fbt-hint></p>' : '') +
        '<div class="fbt__buy"><div class="fbt__total">Total (<span data-fbt-count></span>): <strong data-fbt-total></strong></div>' +
        '<button type="button" class="btn btn--primary" data-fbt-add>Agregar al carro</button></div>';
      fbt.querySelectorAll('[data-fbt-check]').forEach(function (chk) {
        chk.addEventListener('change', function () { items[parseInt(chk.getAttribute('data-fbt-check'), 10)].checked = chk.checked; render(); });
      });
      fbt.querySelector('[data-fbt-add]').addEventListener('click', function () {
        var btn = this; btn.disabled = true; btn.textContent = 'Agregando…';
        var checked = items.filter(function (it) { return it.checked !== false; });
        var extras = checked.length - 1;
        var pct = pctFor(extras);
        var code = pct > 0 ? (extras >= 2 ? disc.c2 : disc.c1) : '';
        var add = checked.map(function (it) { return { id: it.vid, quantity: 1 }; });
        fetch((cfg.addUrl || '/cart/add') + '.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: add })
        }).then(function () {
          if (code) {
            window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(cfg.cartUrl || '/cart');
          } else if (cfg.cartDrawer) {
            refreshCart(true); btn.disabled = false; btn.textContent = 'Agregar al carro';
          } else {
            window.location.href = cfg.cartUrl || '/cart';
          }
        }).catch(function () { btn.disabled = false; btn.textContent = 'Agregar al carro'; });
      });
      if (section) section.hidden = false;
      render();
    });
  }

  // Recently viewed (localStorage)
  (function () {
    var KEY = 'etb_recently';
    var cur = document.querySelector('[data-rv-current]');
    var list = [];
    try { list = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) {}
    var curId = null;
    if (cur) {
      curId = cur.getAttribute('data-id');
      var item = { id: curId, title: cur.getAttribute('data-title'), image: cur.getAttribute('data-image'), price: parseInt(cur.getAttribute('data-price'), 10), url: cur.getAttribute('data-url') };
      list = list.filter(function (x) { return x.id !== curId; });
      list.unshift(item);
      list = list.slice(0, 12);
      try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    }
    var box = document.querySelector('[data-recently-viewed]');
    if (!box) return;
    var show = list.filter(function (x) { return x.id !== curId; }).slice(0, 10);
    var section = box.closest('[data-rv-section]');
    if (!show.length) { if (section) section.remove(); return; }
    var row = box.querySelector('[data-rv-row]');
    if (row) row.innerHTML = show.map(function (p) {
      return '<div class="card"><a href="' + p.url + '" class="card__media">' + (p.image ? '<img src="' + p.image + '" alt="" loading="lazy">' : '') + '</a>' +
        '<div class="card__body"><a href="' + p.url + '" class="card__title">' + p.title + '</a>' +
        '<div class="card__price"><div class="price"><span class="price__current">' + formatMoney(p.price) + '</span></div></div>' +
        '<a href="' + p.url + '" class="btn btn--primary btn--block card__cta">Ver</a></div></div>';
    }).join('');
    if (section) section.hidden = false;
  })();

  // Quantity breaks (display): clicking a tier sets the quantity input
  document.querySelectorAll('[data-qty-break]').forEach(function (b) {
    b.addEventListener('click', function () {
      var q = parseInt(b.getAttribute('data-qty'), 10) || 1;
      var input = document.querySelector('.product__qty input');
      if (input) input.value = q;
      document.querySelectorAll('[data-qty-break]').forEach(function (x) { x.classList.remove('active'); });
      b.classList.add('active');
    });
  });

  // Inicializar barras de recompensa con el total actual del carrito
  updateShipBars(cfg.cartTotal || 0);

  /* ---------- Filtros de colección ---------- */
  (function () {
    var filterForm = document.querySelector('[data-filter-form]');
    var filters = document.querySelector('[data-filters]');
    var scrim = document.querySelector('[data-filter-scrim]');
    var openBtn = document.querySelector('[data-filter-open]');
    var closeBtn = document.querySelector('[data-filter-close]');

    function openFilters() { if (filters) filters.classList.add('open'); if (scrim) scrim.classList.add('open'); document.body.style.overflow = 'hidden'; }
    function closeFilters() { if (filters) filters.classList.remove('open'); if (scrim) scrim.classList.remove('open'); document.body.style.overflow = ''; }
    if (openBtn) openBtn.addEventListener('click', openFilters);
    if (closeBtn) closeBtn.addEventListener('click', closeFilters);
    if (scrim) scrim.addEventListener('click', closeFilters);

    // Auto-aplicar al marcar/desmarcar en escritorio; en móvil se usa "Aplicar"
    if (filterForm) {
      filterForm.querySelectorAll('input[type="checkbox"]').forEach(function (cb) {
        cb.addEventListener('change', function () {
          if (window.innerWidth > 900) filterForm.submit();
        });
      });
    }

    // Orden: conserva los filtros activos en la URL
    var sortSel = document.querySelector('[data-sort]');
    if (sortSel) {
      sortSel.addEventListener('change', function () {
        var u = new URL(window.location.href);
        u.searchParams.set('sort_by', sortSel.value);
        u.searchParams.delete('page');
        window.location.href = u.toString();
      });
    }
  })();

  /* ---------- Cart page quantity steppers (fallback, no drawer) ---------- */
  document.querySelectorAll('[data-cart-plus]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = document.querySelector('input[data-key="' + btn.dataset.key + '"]');
      if (input) { input.value = (parseInt(input.value, 10) || 0) + 1; input.form.submit(); }
    });
  });
  document.querySelectorAll('[data-cart-minus]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = document.querySelector('input[data-key="' + btn.dataset.key + '"]');
      if (input) { input.value = Math.max(0, (parseInt(input.value, 10) || 0) - 1); input.form.submit(); }
    });
  });
})();
